import { Button, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/footer";
import Header from "../../components/header";
import HelmetSeo from "../../components/helmetSeo";
import { API } from "../../config/Api";
import { POST } from "../../utils/apiRequest";
import ItemCard from "./components/itemCard";
import "./styles.scss";
import SummaryScreen from "./components/summaryScreen";
import Loading from "../../components/loading";
import { clearOffers } from "../../redux/slice/offersSlice";

function BookingScreen() {
  const dispatch = useDispatch();
  const [offers, setOffers] = useState([]);
  const [summaryModal, setSummaryModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const selectedOffers = useSelector(
    (state: any) => state.offers.selectedOffers
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      let obj = {
        publish: true,
      };
      setIsLoading(true);
      let api = API.OFFERS_LIST;
      const response: any = await POST(api, obj);
      if (response?.status) {
        let filteredOffers = response?.data.filter(
          (offer: any) => !offer.title?.startsWith("Ticket")
        );
        setOffers(filteredOffers);
        setIsLoading(false);
      } else {
        console.log("no offers");
        setIsLoading(false);
        notification.error({
          message: response?.message,
        });
      }
    } catch (err) {
      console.log(err, "err ---- >", err);
      setIsLoading(false);
      notification.error({
        message: "Something Went Wrong",
      });
    }
  };

  const handleClearSelection = () => {
    dispatch(clearOffers());
  };

  return (
    <div className="mainBox">
      <HelmetSeo
        title="Book your Tickets"
        description={`Book your Ticket Today and Enjoy Unlimited Fun and Adventure!`}
        image="https://bairuha-bucket.s3.ap-south-1.amazonaws.com/teenzania/seo/booknow.webp"
        canonicalurl="https://www.teenzania.com/booking"
        imageAlt="Book Now"
      />
      <Header />

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Container>
            <Row>
              <div className="headingTxt">
                <br />
                <br />
                Choose the adventures you wanted to experience
              </div>
              <div className="subHeadingTxt mt-3">
                Enjoy the adventures you like by clicking book ticket. Add how
                many participants will be there then click the Confirm Booking
                button to
                <br />
              </div>
              <div className="subHeadingTxt mb-5">
                finish. If you wish to remove a specific adventure from
                selection just click on the clear booking button
              </div>

              <Col md={8}>
                <Row className="cardsContainer">
                  {offers.map((offer: any, i: any) => {
                    return (
                      <Col
                        // xs={12}
                        // sm={6}
                        // md={6}
                        // lg={4}
                        md={4}
                        className="d-flex justify-content-center"
                        key={offer.id}
                      >
                        <ItemCard offer={offer} />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
              <Col md={4} className="d-none d-md-block">
                <SummaryScreen
                  selectedOffers={selectedOffers}
                  onClear={handleClearSelection}
                />
              </Col>
            </Row>
          </Container>
          <Col className="d-block d-md-none">
            <div className="mobilePayNowBox">
              <Button
                type="primary"
                onClick={() => setSummaryModal(true)}
                disabled={selectedOffers.length === 0}
              >
                View Details
              </Button>
            </div>
          </Col>
        </>
      )}
      <Modal
        open={summaryModal}
        maskClosable={true}
        className="Modal_BackgroundColor"
        footer={false}
        onCancel={() => setSummaryModal(false)}
      >
        <SummaryScreen
          selectedOffers={selectedOffers}
          onClose={() => setSummaryModal(false)}
          onClear={handleClearSelection}
        />
      </Modal>

      <br />
      <br />
      <Footer />
    </div>
  );
}

export default BookingScreen;
